<template>
    <panel-template>
        <template #bradcrumbs>
            <ui-breadcrumbs design="full">
                <template #left>
                    <span v-if="isManagementLaunch">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Bem vindo </span>
                    </span>

                    <span v-if="isMainData">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Cadastro</span>
                        <span> &#8226; Dados Principais</span>
                    </span>

                    <span v-if="isServicePoints">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Cadastro</span>
                        <span> &#8226; Pontos de Atendimento</span>
                    </span>

                    <span v-if="isOperatorsBox">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Cadastro</span>
                        <span> &#8226; Operadores de Caixa</span>
                    </span>

                    <span v-if="isPaymentMethods">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Cadastro</span>
                        <span> &#8226; Formas de Pagamento</span>
                    </span>

                    <span v-if="isPaymentPlans">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Cadastro</span>
                        <span> &#8226; Formas de Pagamento</span>
                    </span>

                    <span v-if="isCommissioning">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Cadastro</span>
                        <span> &#8226; Comissionamento</span>
                    </span>

                    <span v-if="isComputerServicePoint">
                        <router-link :to="{ name: 'launch.management' }">
                            <span>Gestão de Lançamentos</span>
                        </router-link>
                        <span> &#8226; Definir controle para ponto de atendimento</span>
                    </span>

                </template>
            </ui-breadcrumbs>
        </template>

        <template #content>
            <div v-if="load" class="load">
                <ui-overlay-load />
            </div>
            <router-view :key="$route.fullPath" />
        </template>
    </panel-template>
</template>

<script>
	import { uiBreadcrumbs, uiOverlayLoad } from '@/components/ui'
	import PanelTemplate from '@/templates/page-panel-center'
	import { mapGetters } from 'vuex'

	export default {
		name: 'ui-launch-management',

		components: {
			PanelTemplate,
			uiBreadcrumbs,
			uiOverlayLoad
		},
		
		computed: {
			...mapGetters('launchDay', { load: 'getPreLoad' }),
			isManagementLaunch() {
				return ['launch.management.list'].includes(this.$route.name)
			},
			isMainData() {
				return ['launch.management.create.mainData'].includes(this.$route.name)
			},
			isServicePoints() {
				return ['launch.management.create.servicePoints'].includes(this.$route.name)
			},
			isOperatorsBox() {
				return ['launch.management.create.boxOperators'].includes(this.$route.name)
			},
			isPaymentMethods() {
				return ['launch.management.create.paymentMethods'].includes(this.$route.name)
			},
			isPaymentPlans() {
				return ['launch.management.create.paymentPlans'].includes(this.$route.name)
			},
			isCommissioning() {
				return ['launch.management.create.commissioning'].includes(this.$route.name)
			},
			isComputerServicePoint(){
				return ['launch.management.computerServicePoint'].includes(this.$route.name)
			},
		},

		mounted() {
			// if (this.load && this.$route.name !== 'launch.management.list') {
			// 	this.$router.push({ name: 'launch.management.list' })
			// }
		}
	}
</script>

<style lang="stylus" scoped>
	.load
		width 100%
		height: 100%
		background #ebf1f8
		position absolute
		top 0
		left 0
		z-index 200
	.chain
		width 100%
		padding: 0 20%
		display: flex
		justify-content: center
	@media (max-width: 1370px)
		.chain
			padding: 0 10%
			min-width: 800px
	@media (max-width: 1060px)
		.chain
			padding 0 30px
</style>
